import { MenuItem } from "./menu.model";

export const CustomerMENU: MenuItem[] = [
    {
        id: 8,
        label: 'dashboard',
        icon: 'ph-squares-four',
        link: '/customer-dashboard',
    },
    {
        id: 9,
        label: 'reserve_facility',
        icon: 'ph-trophy',
        link: '/reserve-facility',
    },
    {
        id: 10,
        label: 'my_reserves',
        icon: 'ph-calendar-blank',
        link: '/customer-reserves',
    },
    {
        id: 11,
        label: 'payments',
        icon: 'ph-credit-card',
        link: '/payments',
    },
    {
        id: 12,
        label: 'profile',
        icon: 'ph-user',
        link: '/customer-profile',
    },
]